//账号找回密码，修改密码模块

//引入接口文档
import req from '@/utils/req.js'

//修改密码接口
export function api_changepwd(params) {
    return req.put("/admin/user/change/password",params);
}

